export default __webpack_public_path__ + "static/media/lines.809fc1ea.svg";